import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/service/utility.service';
import { SurveyService } from '../service/survey.service';
import { ClientListInfoService } from 'src/app/_metronic/layout/core/client-list-info.service';
import { NotifierService } from 'angular-notifier';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SendMailModalComponent } from './send-mail-modal/send-mail-modal.component';
import { SendCommComponent } from './send-comm/send-comm.component';

@Component({
  selector: 'app-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.scss'],
})
export class SurveyListComponent implements OnInit,OnDestroy {
  public surveys:any;
  public isSurvayListCallDone:boolean=false;
  public surveyStatusFilter:string = "";
  public shareInventoryPopUp:boolean = false;
  public shareInventoryContainer:any = {};
  public accessRoles:any={};
  public switchUserAccess:boolean = false;
  public mainSurveys:any;
  private sendCommModalRef: null | any = null;

  constructor(
    private route:Router,
    public surveyService:SurveyService,
    private cd: ChangeDetectorRef,
    public utility: UtilityService,
    private clientService:ClientListInfoService,
    private notifier:NotifierService,
    private ngbModal: NgbModal
    ) { 
      this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
      this.accessRoles = this.accessRoles.access_rules;
    }

  ngOnDestroy(): void {
    // Re-enable scroll on html element
    document.documentElement.style.overflowY = '';
    
    if (this.sendCommModalRef) {
        this.sendCommModalRef.close();
        this.cleanupSendCommModalRef();
    }
    this.utility.resetSortColumn();
    this.surveyService.sendMailData = undefined;
  }

  ngOnInit(): void {
    // Disable scroll on html element (data-theme="light")
    document.documentElement.style.overflowY = 'hidden';
    
    this.surveyService.surveyDetails = {};
    this.getSurvayList();
    this.checkSwitchUserAccess();
    if(this.switchUserAccess) this.initSendMailPopup();
  }

  
  checkSwitchUserAccess(){
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
      this.getShareInventoryList();
    }
  }

  // dummySurveys() {
  //   return [
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'
  //     },
  //     {
  //       survey_name:"Abcd xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

        
  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     },
  //     {
  //       survey_name:"Study xyz",
  //       start_date:'20 Jun 2022',
  //       end_date:'22 jun 2022',
  //       expected_cpi:'100',
  //       expected_loi:'200',
  //       expected_ir:'10%',
  //       sample_size:'50/100',
  //       survey_link:'https://crownit.in/en?track={$pid}&status=complete'

  //     }
  //   ]
  // }
  StudyDetails(survey:any){
    // this.route.navigate(['/survey/details/e5d5703d-1231-11ed-b92f-f0d5bfd3c882']);
    this.route.navigate(['/survey/details/',survey.uuid]);
    this.surveyService.surveyReport = survey;
    localStorage.removeItem('redirectFromCompletionSurveyDetails');
    localStorage.removeItem('selected_container');
    this.surveyService.redirectFromInventory = true;
    this.surveyService.redirectFromCompletion = false;
    // this.surveyService.getQuotaDetails('e5d5703d-1231-11ed-b92f-f0d5bfd3c882').subscribe((result:any) =>
    // {
    //   // console.log(result,'Getting Result');
    // })
  }
  launchSurvey(survey:any){
  survey.isSurveyLaunching = true;
  this.surveyService.launcgSurvay(survey.uuid)
      .subscribe({
        next :(res:any) =>{
          if (res['status'] == 1) {
            // this.surveys = res.result;
            // this.cd.detectChanges();
            res['message'] = (res['message'] && res['message'] !='') ? res['message'] : 'Survey Launched Successfully';
            this.notifier.notify('success',res.message);
          } else if (res['status'] == 2 && res['message']) {
            this.notifier.notify('info',res.message);
          } else if (res['status'] == 0 && res['message']) {
            this.notifier.notify('error',res.message);
          }
          survey.isSurveyLaunching = false;
        },
        error: (e) =>{
          console.log(e);
          this.notifier.notify('error',"Could Not Launch Survey");
          survey.isSurveyLaunching = false;
        },
        complete:() => {
          // this.isSurvayListCallDone = true
          // this.cd.detectChanges();
          survey.isSurveyLaunching = false;
        }
      })
  }

  copyOnClick(str:string){
    this.utility.copyOnClick(str)
  }

  getSurvayList(){
    this.isSurvayListCallDone = false;
    this.surveyService.getSurvayList()
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.surveys = res.result;
          // this.surveys = [];
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
        
      },
      complete:() => {
        this.isSurvayListCallDone = true
        this.cd.detectChanges();
      }
    })
  }


  getClientBasedSurvayList(status:any){
    this.isSurvayListCallDone = false;
    this.surveyService.getClientBasedSurvayList(status)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.surveys = res.result;
          // this.surveys = [];
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
        
      },
      complete:() => {
        this.isSurvayListCallDone = true
        this.cd.detectChanges();
      }
    })
  }

  applyFilter(){
    if(this.surveyStatusFilter && this.surveyStatusFilter != '')
    {
      this.getClientBasedSurvayList(this.surveyStatusFilter);
    }
    else
    {
      this.notifier.notify('error','Please Select Status');
    }
  }

  resetFilter(){
    this.surveyStatusFilter = "";
    this.getSurvayList();
  }


  openSharePopup(){
    this.shareInventoryPopUp = !this.shareInventoryPopUp;
  }


  // closePopup(event:any){
  //   event.stopPropagation();
  //   myDrop.close();

  //   // this.shareInventoryPopUp = false;
    
  // }


  getShareInventoryList(){
    this.surveyService.getShareInventoryList()
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.shareInventoryContainer = {'users':res['users'],'overall_text':res.overall_text };
          this.cd.detectChanges();
        }
        if(res['status'] == 2){
          this.shareInventoryContainer = {'users':res['users'],'overall_text':res.overall_text };
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
      },
      complete:() => {
        this.cd.detectChanges();
      }
    })
  }


  // Sendtowhatsapp(item:any){
  //   console.log(item);
  // }


  CreateUrl(item:any){
    let phone = item.phone;
    if(item.phone.length > 10 && item.phone.startsWith('+91')){
      phone = item.phone.substr(3,item.phone.length);
    }
    return `https://api.whatsapp.com/send?text=${item.message}&phone=+91${phone}`;
  }



  copyClipBoard(msg:any){
    let arr = msg.split('%0A');
    let new_msg = arr.length > 0 ? arr.join("\n"):msg;
    this.utility.copyOnClick(new_msg);
  }

  initSendMailPopup(popup?:boolean) {
    if(!this.surveyService.sendMailData) {
      this.surveyService.getNewlyAddedSurveysWithEmails()
      .subscribe(({data, error}) => {
        if(data && data.status === 1) {
          this.surveyService.sendMailData = {emails: data.emails, surveys: data.survey_data};
          popup && this.openSendMailPopup();
        } else popup && this.notifier.notify('error', "Could Not Get Newly Added Surveys Details");
      })
    } else popup && this.openSendMailPopup();
  }

  openSendMailPopup() {
    if(this.surveyService.sendMailData && !this.surveyService.sendMailData.surveys.length) return this.notifier.notify('info', "No Study Available to Share");
    if(this.surveyService.sendMailData && !this.surveyService.sendMailData.emails.length) return this.notifier.notify('info', "No Users Available");

    const options: NgbModalOptions = {
      modalDialogClass: "send-mail-dialog-class",
      backdropClass: "send-mail-backdrop-class",
      windowClass: "send-mail-window-class",
      size: 'lg',
      backdrop: 'static'
    };
    const sendMailModalRef = this.ngbModal.open(SendMailModalComponent, options);
    sendMailModalRef.componentInstance.data = {...this.surveyService.sendMailData, ref: sendMailModalRef};
  }

  openSendCommPopup(survey: any) {
    const options: NgbModalOptions = {
      modalDialogClass: "send-comm-dialog-class",
      backdropClass: "send-mail-backdrop-class",
      windowClass: "send-mail-window-class",
      size: 'lg',
      backdrop: 'static',
    };
    const sendCommData = { ...survey };
    const sendCommModalRef = this.ngbModal.open(SendCommComponent, options);
    sendCommModalRef.componentInstance.data = {
        ...sendCommData,
        ref: sendCommModalRef,
        onClose: () => this.cleanupSendCommModalRef()
    };
    this.sendCommModalRef = sendCommModalRef;
}

cleanupSendCommModalRef() {
  this.sendCommModalRef = null; // Ensure the reference is cleared
}

}
